import React from 'react';
import PropTypes from 'prop-types';
import { PaymentPlanForm } from '@/lib/components/PaymentPlan/components/PaymentPlanForm';
import './PaymentPlan.module.scss';

const PaymentPlan = ({
    paymentData,
    paymentRequestId,
    lyriaUrl,
    onPaymentResult,
    config,
    lang,
}) => {
    return (
        <div id="paymentplan">
            <PaymentPlanForm
                paymentData={paymentData}
                lyriaUrl={lyriaUrl}
                paymentRequestId={paymentRequestId}
                onPaymentResult={onPaymentResult}
                config={config}
                lang={lang}
            />
        </div>

    );
};

PaymentPlan.propTypes = {
    /**
     * The paymentRequestID to use in order to be able to call the backend when we submit the data in the paymentPage.
     */
    paymentRequestId: PropTypes.string,
    /**
     * The backend url to use to pass the form data.
     */
    lyriaUrl: PropTypes.string,
    /**
     * Object containing the attendee's personal information (first name, last name, phone number, ...).
     */
    paymentData: PropTypes.object,
    /**
     * The callback function to trigger when the backend return the result of the form data submit.
     */
    onPaymentResult: PropTypes.func,
    /**
     * The specific configuration related to this payment method.
     */
    config: PropTypes.object,
};

export default PaymentPlan;
